import React, { useState, useCallback } from 'react';
import {
  Button, Popup, Input, Loader, Icon,
} from 'semantic-ui-react';
import { solscanUrl } from 'utils/companies';
import toast from 'react-hot-toast';
import styled from 'styled-components';
import api from 'api';

const HashVerificationContainer = styled.div`
  ${({ loading }) => loading && `
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    .ui.loader {
      display: block;
    }
  `}
  .ui.input {
    width: 500px;
    font-size: 0.8em;
    color: gray;
  }
  .view-on-ether {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    > a {
      font-size: 0.8em;
      text-decoration-line: underline;
    }
  }
  .hashVerified {
    display: flex;
    .i {
      margin-right: 10px;
    }
    a {
      display: block;
      font-weight: bold;
      text-decoration-line: underline;
      font-size: 0.8em;
      margin-right: 10px;
      line-height: 1.5em;
    }
  }  
  .confirmed-match {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .i {
      margin-right: 10px;
    }
    span {
      display: block;
      font-weight: bold;
      font-size: 0.9em;
      line-height: 1.6em;
    }
  }
`;

const ChallengeIPStatementHashVerification = ({
  ipStatement, challengeId,
}) => {
  const [result, setResult] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const statementId = ipStatement?._id;

  const hashStatement = useCallback(() => {
    setLoading(true);
    api.challenges.rehashIpStatement(challengeId, statementId, (data) => {
      setResult(data);
      setLoading(false);
    }, (err) => {
      toast.error(err.message);
      setLoading(false);
    });
  }, [statementId, challengeId]);

  const { ipmServiceResponse, ipfsHash } = result;

  return (
    <Popup
      onOpen={hashStatement}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      size='huge'
      position='bottom right'
      content={(
        <HashVerificationContainer loading={loading}>
          {loading
            ? (
              <Loader active />
            ) : (
              <React.Fragment>
                {ipStatement?.tokenAccount
                  ? (
                    <div className='hashVerified'>
                      <Icon
                        name='check circle'
                        color='green'
                        size='large'
                      />
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        href={`${solscanUrl}${ipStatement.tokenAccount}#metadata`}
                      >
                        View IP asset on the blockchain
                      </a>
                    </div>
                  ) : <div />
                }
                <h5>IP Statement content</h5>
                <Input value={ipStatement.statementContent} />
                <h5>Hashed statement content</h5>
                <Input value={ipmServiceResponse} />
                <h5>IPFS hashed statement</h5>
                <Input value={ipfsHash} />
                {ipmServiceResponse === ipfsHash
                  ? (
                    <div className='confirmed-match'>
                      <Icon
                        name='check circle'
                        color='green'
                        size='large'
                      />
                      <span>
                        Hash match confirmed
                      </span>
                    </div>
                  ) : null
                }
                <div className='view-on-ether'>
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`${solscanUrl}${ipStatement.tokenAccount}`}
                  >
                    Verify on Solana blockchain
                  </a>
                </div>
              </React.Fragment>
            )
          }
        </HashVerificationContainer>
      )}
      on='click'
      trigger={(
        <Button
          size='small'
          onClick={() => setIsOpen(true)}
        >
          Verification
        </Button>
      )}
    />
  );
};

export default ChallengeIPStatementHashVerification;
